<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  body {
    background-color: #f7f8fa;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue